import PropTypes from 'prop-types'
import SubmitButton from '../common/buttons/SubmitButton'
import styles from './EventInProgressCard.module.scss'

const EventInProgressCard = ({ onClick }) => (
  <div className={styles.messageCard}>
    <i className='fa fa-exclamation-triangle' />
    <span className='ml-3'>Quick Log Event In-Progress</span>
    <div className={styles.continueEditingButton}>
      <SubmitButton
        className='mb-3'
        buttonMessage='Continue Editing'
        buttonColor='orange-button'
        onClick={onClick}
      />
    </div>
  </div>
)

EventInProgressCard.propTypes = {
  onClick: PropTypes.func.isRequired,
}

export default EventInProgressCard
